import StackTrace from 'stacktrace-js';
import type { ComponentInternalInstance, ComponentPublicInstance } from 'vue';

import type { ErrorToHandle } from '@/services/errorHandler/types';
import type { VglError } from '@/services/errorHandler/vglError';

export const errorStackTraceReader = (
  error: VglError,
  instance: ComponentPublicInstance | ComponentInternalInstance | null,
  info: string,
): Promise<ErrorToHandle> =>
  StackTrace.fromError(error).then((stackTrace) => {
    const vglError: ErrorToHandle = {
      timestamp: new Date(),
      stackTrace,
      error,
      instance,
      info,
    };

    return vglError;
  });
